/**
 * Service/Ob (Object Storage) Controller
 *
 * Displays information about object storage orders
 */

// the constructor for this object
function ServiceObController() { }

// the object
ServiceObController.prototype = {
    constructor: ServiceObController,
    
    // the base order id
    baseOrderId: false,
    
    // store the bytes chart data
    BytesGraph: false,
    
    // store the bytes chart data
    OperationsGraph: false,
    
    // this contains the pagination object
    pagination: false,
    
    // the number of order per page
    perPage: 10,
    
    // the last data submitted to the API, used to prevent multiple api requests
    lastSubmittedData: {},
    
    // initialize the controller
    init: function() 
    {
        // the user must be logged in to access this page
        PortalMain.authRedirect();
        
        // register the route variables used by this controller
        this._registerRouteVariables();
        
        // setup the pagination
        this._setupPagination();
        
        // register charts 
        this._registerCharts();
        
        PortalHelper.debugMessage('Service Object Storage Initialized');
    },
    
    // run the controller
    run: function()
    {
        // register the pagination events
        this.pagination.init();
        
        // get and populate the orders
        this._getOrder();
        
        // get/populate the object storage specific order info
        this._getObOrder();
        
        // get order stats
        this._getOrderStats();
        
        // get the orders vms
        this._getBuckets();
        
        // register the events used by this controller
        this._registerEvents();
        
        PortalHelper.debugMessage('Service Object Storage Controller Ran');
    },
    
    // get the route variables and include them in the controller
    _registerRouteVariables: function() 
    {
        var segments = PortalMain.getRouteSegments();
        
        // set the product cd
        if (segments.length == 1) {
            this.baseOrderId = segments[0];
        } else {
            // the uri is missing important pieces
            PortalHelper.sendToDashboard();
        }
    },
    
    // register the javascript events
    _registerEvents:  function() 
    {   
        // bind to any of the dropdown links
        PortalHelper.hideDropdownOnClick('#range-selection-dropdown');
        $('#range-selection-dropdown ul li a').on('click', function(){
            PortalMain.ServiceObController._updateChartRange(
                this.dataset.timelineRangeSeconds
            );
            
            PortalMain.ServiceObController._updateSelectedRange(this);
        });
    },
    
    // create the pagination object
    _setupPagination: function()
    {
        var pagination = new PortalPagination;
        pagination.perPage = this.perPage;
        pagination.paginationSelector = '#buckets-pagination';
        pagination.contentSelector = '#buckets-table';
        pagination.searchSelector = '#buckets-search';
        pagination.searchColumn = 'search_bucket';
        pagination.eventCallback = PortalMain.ServiceObController._getBuckets;
        PortalMain.ServiceObController.pagination = pagination;
    },
    
    // register the chart
    _registerCharts: function()
    {
        // new chart for usage history
        var BytesGraph = new PortalChart;
        BytesGraph.elementId = 'bytes-chart';
        BytesGraph.type = 'line';
        BytesGraph.dataFormat = 'bytes';
        BytesGraph.columns = [];
        this.BytesGraph = BytesGraph;
        
        // new chart for operations history
        var OperationsGraph = new PortalChart;
        OperationsGraph.elementId = 'objects-chart';
        OperationsGraph.type = 'line';
        OperationsGraph.dataFormat = 'number';
        OperationsGraph.columns = [];
        this.OperationsGraph = OperationsGraph;
    },
    
    // get the orders from the api
    _getOrder: function()
    {
        PortalMain.ServiceIndexController = new ServiceIndexController;
        
        PortalMain.ServiceIndexController.baseOrderId = this.baseOrderId;
        
        PortalMain.ServiceIndexController._getOrder();
    },
    
    // get Object Storage specific order info (usage information)
    _getObOrder: function()
    {
        var obOrderRequest = new PortalRequest;
        obOrderRequest.errorElement = '.order-fail';
        obOrderRequest.makeRequest(
            '/orders-ob/get-order-ob',
            {
                baseOrderId: this.baseOrderId,
            },
            function(data) {
                PortalMain.ServiceObController._populateObOrderInfo(data);
                PortalMain.ServiceObController._populateObOrderRates(data);
            },
            function() {
                PortalMain.ServiceObController._hideWidgets();
            }
        )
    },
    
    // populate document with usage information
    _populateObOrderInfo: function(obInfo)
    {
        var storage = PortalHelper.formatBytes(obInfo.latest_size);
        $('#storage span:nth-child(1)').text(storage[0]);
        $('#storage span:nth-child(2)').text(storage[1]);
        
        var buckets = obInfo.latest_bucket_count;
        $('#buckets span:nth-child(1)').text(buckets);
        
        if (obInfo.max_size <= -1) {
            $('#max-size span:nth-child(1)').text('None');
            $('#max-size span:nth-child(2)').remove();
        } else {
            var maxSize = PortalHelper.formatBytes(obInfo.max_size);
            $('#max-size span:nth-child(1)').text(maxSize[0]);
            $('#max-size span:nth-child(2)').text(maxSize[1]);
        }
        
        PortalHelper.loadingOverlay('.stats', false);
    },

    // fill in and display the per GB rate
    _populateObOrderRates: function(obInfo)
    {
        // set the per gb rate
        if (obInfo.per_gb_rate != undefined) {
            var perGbRate = $('#usage-rates .clone-source').clone();
            perGbRate.removeClass('clone-source');

            $('.rate-label', perGbRate).text('Per GB Rate');

            var rate = obInfo.per_gb_rate;
            rate = PortalHelper.numberToDollars(rate, 2, true);
            $('.rate-amount', perGbRate).text(rate);

            $('#usage-rates').append(perGbRate);

            // show the usage rates
            $('#usage-rates').removeClass('hidden');
        }
    },

    // hide the OB widgets, as no order was found
    _hideWidgets: function()
    {
        $('.ob-widget').remove();
    },
    
    // retrieves historical usage information to fill our usage chart with
    _getOrderStats: function(startDate, endDate)
    {
        // defaulting to 1 month range if a start or end date not passed
        if(!(startDate instanceof Date) || !(endDate instanceof Date)) {
            var startDate = new Date();
            var endDate = new Date();
            
            startDate.setMonth(
                startDate.getMonth() - 1
            );
        }
        
        var orderStatsRequest = new PortalRequest;
        orderStatsRequest.makeRequest(
            '/orders-ob/get-ob-stats',
            {
                baseOrderId: this.baseOrderId,
                // Date() strikes again. Dividing by 1000 here to get seconds instead of ms
                startDate: startDate.getTime() / 1000|0,
                endDate: endDate.getTime() / 1000|0,
            },
            function(data) {
                PortalMain.ServiceObController._populateBytesChart(data, startDate, endDate);
                PortalMain.ServiceObController._populateOperationsChart(data, startDate, endDate);
            }
        );
    },
    
    // sets up the bytes graph, populating columns and data
    _populateBytesChart: function(chartData, startDate, endDate)
    {
        // keep only the specified columns for the chart
        chartData = PortalHelper.chartGetColumns(chartData, [
            'Time',
            'Storage'
        ]);
            
        this.BytesGraph.minDate = startDate;
        this.BytesGraph.maxDate = endDate;
        
        // resetting columns first
        this.BytesGraph.columns = [];
        for(var i in chartData[0]) {
            var currentField = chartData[0][i];
            if(currentField == 'Time') {
                this.BytesGraph.columns[i] = ['date', currentField];
            } else {
                this.BytesGraph.columns[i] = ['number', currentField];
            }
        }
        
        if(chartData.length == 1) {
            $('#bytes-chart').text("No data available for this period.");
        } else {
            this.BytesGraph.data = chartData;
            this.BytesGraph.draw();
        }
        PortalHelper.loadingOverlay('#bytes-chart', false);        
    },
    
    // sets up the uoperations graph, populating columns and data
    _populateOperationsChart: function(chartData, startDate, endDate)
    {
        // keep only the specified columns for the chart
        chartData = PortalHelper.chartGetColumns(chartData, [
            'Time',
            'Objects Stored'
        ]);
        
        this.OperationsGraph.minDate = startDate;
        this.OperationsGraph.maxDate = endDate;
        
        // resetting columns first
        this.OperationsGraph.columns = [];
        for(var i in chartData[0]) {
            var currentField = chartData[0][i];
            if(currentField == 'Time') {
                this.OperationsGraph.columns[i] = ['date', currentField];
            } else {
                this.OperationsGraph.columns[i] = ['number', currentField];
            }
        }
        
        if(chartData.length == 1) {
            $('#objects-chart').text("No data available for this period.");
        } else {
            this.OperationsGraph.data = chartData;
            this.OperationsGraph.draw();
        }
        PortalHelper.loadingOverlay('#objects-chart', false);        
    },
    
    // changes what date range is displayed
    _updateChartRange: function(dateRangeSeconds)
    {
        PortalHelper.loadingOverlay('#bytes-chart', true);
        PortalHelper.loadingOverlay('#objects-chart', true);
            
        var endDate = new Date();
        var startDate = new Date(
            endDate.getTime() 
            - (dateRangeSeconds * 1000)
        );
        
        this._getOrderStats(startDate, endDate);
    },
    
    // adds interactivity to the dropdown range selection
    _updateSelectedRange: function(element)
    {
        var selectedElementText = $(element).text();
        $('.selection-text').text(selectedElementText);
    },
    
    // get Object Storage specific order info (usage information)
    _getBuckets: function()
    {
        // get the submission data from the pagination object
        var submissionData = PortalMain.ServiceObController.pagination.getBaseSubmissionData();
        
        // include the base order id
        submissionData.baseOrderId = PortalMain.ServiceObController.baseOrderId;
        
        // make sure the new request isn't the same as the previous one
        if (JSON.stringify(submissionData) == JSON.stringify(PortalMain.ServiceObController.lastSubmittedData)) {
            PortalMain.ServiceObController.pagination.showPagination();
            return;
        }
        PortalMain.ServiceObController.lastSubmittedData = submissionData;
        
        var bucketsRequest = new PortalRequest;
        bucketsRequest.pageNumber = submissionData.page;
        bucketsRequest.makeRequest(
            '/orders-ob/get-buckets',
            submissionData,
            function(data) {
                
                //handle pagination 
                PortalMain.ServiceObController.pagination.updatePagination(data);
                PortalMain.ServiceObController.pagination.showPagination();
                
                // get the last pagination event
                var lastEvent = PortalMain.ServiceObController.pagination.lastEvent;
                
                // fill the vm table
                PortalMain.ServiceObController._populateBuckets(data, lastEvent);
            }
        )
    },
    
    // fill in the buckets table
    _populateBuckets: function(bucketsData, lastPaginationEvent)
    {
        var buckets = bucketsData.data;
        
        // clear the old vms
        if (lastPaginationEvent != 'more') {
            $('#buckets-table tbody tr:not(.clone-source)').remove();
        }
        
        // add the new vms to the DOM
        for (var i in buckets) {
            var bucket = buckets[i];
            var newEntry = $('#buckets-table tbody .clone-source').clone();
            newEntry.removeClass('clone-source');
            
            // apply the name
            $('.bucket-name', newEntry).html(bucket.bucket);
            
            // apply the storage
            var storage = PortalHelper.formatBytes(bucket.size);
            $('.storage', newEntry).html(storage);
            
            // apply the number of objects
            var objects = bucket.num_objects;
            $('.objects', newEntry).html(objects);
            
            // add to to the table
            $('#buckets-table tbody').append(newEntry);
        }
    }
    
}